{
  "validation": {
    "subjectRequired": "Subject is required.",
    "messageRequired": "Message field cannot be empty.",
    "messageMaxLength": "Message can be at most 3000 characters long.",
    "categoryRequired": "Message category is required."
  },
  "view": {
    "title": "All messages",
    "description": "We strive to respond to messages as quickly as possible, usually within three days.",
    "messageTitle": "Message",
    "empty": "No messages",
    "hideConversation": "Hide conversation",
    "showConversation": "Show conversation",
    "sendNewMessage": "New message",
    "newBadge": "New",
    "replyToMessage": "Reply to message",
    "reply": "Reply",
    "previous": "All messages",
    "noTitle": "(no subject)"
  },
  "form": {
    "replyPrefix": "RE:",
    "subject": "Subject",
    "category": "Message category",
    "selectCategory": "Select what your message concerns",
    "noCategory": "No category",
    "categoryLoadError": "Message categories could not be loaded. Please try again.",
    "retry": "Try again",
    "message": "Message",
    "attachments": "Attachments",
    "send": "Send",
    "cancel": "Cancel",
    "errorTitle": "An error occurred while sending the message.",
    "successTitle": "Message sent successfully!",
    "visibleToAllParticipants": "Your reply will be visible to all participants in the conversation."
  }
}
